import type { IRouteItem, MenuItem } from "@/app/ui/navigation/types";
import { salesMenu, buildSalesMenuItems } from "@/app/ui/navigation/salesMenu";
import {
  contactsMenu,
  buildContactsMenuItems,
} from "@/app/ui/navigation/contactsMenu";
import { stockMenu, buildStockMenuItems } from "@/app/ui/navigation/stockMenu";
import {
  distributionMenu,
  buildDistributionMenuItems,
} from "@/app/ui/navigation/distributionMenu";
import {
  productionMenu,
  buildProductionMenuItems,
} from "@/app/ui/navigation/productionMenu";
import {
  buildPricingMenuItems,
  pricingRoutes,
} from "@/app/ui/navigation/pricingMenu";
import {
  containerTrackingMenu,
  buildContainerTrackingMenuItems,
} from "@/app/ui/navigation/containerTrackingMenu";
import { buildDutyMenuItems } from "@/app/ui/navigation/dutyMenu";
import {
  reportingMenu,
  buildReportingMenuItems,
} from "@/app/ui/navigation/reportingMenu";
import {
  integrationsMenu,
  buildIntegrationsMenuItems,
} from "@/app/ui/navigation/integrationsMenu";
import {
  adminRoutes,
  buildAdministrationMenuItems,
} from "@/app/ui/navigation/administrationMenu";
import {
  buildSupportMenuItems,
  supportRoutes,
} from "@/app/ui/navigation/supportMenu";
import {
  galleryRoutes,
  buildGalleryMenuItems,
} from "@/app/ui/navigation/galleryMenu";
import { mainMenu, buildMainMenuItems } from "@/app/ui/navigation/mainMenu";
import {
  buildUllagesMenuItems,
  ullageRoutes,
} from "@/app/ui/navigation/ullagesMenu";
import {
  distributionAppMenu,
  buildDistributionAppItems,
} from "./distributionAppMenu";
import { accountRoutes } from "@/app/ui/navigation/accountManagement";
import { dutyMenuUk } from "@/app/ui/navigation/dutyMenuUk";
import { dutyMenuGerman } from "@/app/ui/navigation/dutyMenuGerman";
import { dutyMenuAustralian } from "@/app/ui/navigation/dutyMenuAustralian";
import {
  buildUnauthorisedItems,
  unauthorisedMenu,
} from "@/app/ui/navigation/unauthorisedMenu";
import { batchMenu, buildBatchMenuItems } from "@/app/ui/navigation/batchMenu";
import {
  multiTenantMenu,
  buildMultiTenantMenuItems,
} from "@/app/ui/navigation/multiTenantMenu";

export function buildMenuItems(): MenuItem[] {
  return [
    ...buildMainMenuItems(),
    ...buildSalesMenuItems(),
    ...buildContactsMenuItems(),
    ...buildStockMenuItems(),
    ...buildDistributionMenuItems(),
    ...buildProductionMenuItems(),
    ...buildBatchMenuItems(),
    ...buildUllagesMenuItems(),
    ...buildPricingMenuItems(),
    ...buildContainerTrackingMenuItems(),
    ...buildDutyMenuItems(),
    ...buildReportingMenuItems(),
    ...buildIntegrationsMenuItems(),
    ...buildAdministrationMenuItems(),
    ...buildMultiTenantMenuItems(),
    ...buildGalleryMenuItems(),
    ...buildSupportMenuItems(),
    ...buildDistributionAppItems(),
    ...buildUnauthorisedItems(),
  ];
}

export function buildRouteItems(): IRouteItem[] {
  const fromOldMenus: IRouteItem[] = [
    ...buildMainMenuItems(),
    ...buildSalesMenuItems(),
    ...buildContactsMenuItems(),
    ...buildStockMenuItems(),
    ...buildDistributionMenuItems(),
    ...buildProductionMenuItems(),
    ...buildBatchMenuItems(),
    ...buildContainerTrackingMenuItems(),
    ...buildDutyMenuItems(),
    ...buildReportingMenuItems(),
    ...buildIntegrationsMenuItems(),
    ...buildMultiTenantMenuItems(),
    ...buildSupportMenuItems(),
    ...buildDistributionAppItems(),
    ...buildUnauthorisedItems(),
  ];

  // Because all the keys in Eg ullageRoutes are for IRouteItem
  // typescript knows that these all resolve to IRouteItem
  const fromRoutes = [
    accountRoutes,
    ullageRoutes,
    pricingRoutes,
    galleryRoutes,
    supportRoutes,
    adminRoutes,
  ]
    .flatMap((x) => Object.entries(x))
    .map((kvp): IRouteItem => kvp[1]);

  return fromOldMenus.concat(fromRoutes);
}

export const routes = {
  mainMenu,
  salesMenu,
  contactsMenu,
  stockMenu,
  distributionMenu,
  productionMenu,
  batchMenu,
  containerTrackingMenu,
  dutyMenuAustralian,
  dutyMenuGerman,
  dutyMenuUk,
  reportingMenu,
  integrationsMenu,
  multiTenantMenu,
  distributionAppMenu,
  unauthorisedMenu,
};
